/** Backend code returned when an admin request originates outside Prisma Access. */
export const ADMIN_IP_DENIED_CODE = "ADMIN_IP_DENIED"

export const ADMIN_IP_DENIED_MESSAGE =
    "Admin access is only allowed from approved network gateways. Connect via Prisma Access (VPN) and try again."

export function isAdminIpDenied(error) {
    return error?.response?.status === 403 && error?.response?.data?.code === ADMIN_IP_DENIED_CODE
}

export function getAdminIpDeniedMessage(error) {
    return error?.response?.data?.error || ADMIN_IP_DENIED_MESSAGE
}
